import React from 'react';
import { Col, Row } from 'react-bootstrap';
import styled from 'styled-components';

import BottomBar from './BottomBar';
import ContactLinks from './ContactLinks';
import NewsletterSubscriptionWidget from './NewsletterSubscriptionWidget';
import SiteLinks from './SiteLinks';
import SocialLinks from './SocialLinks';

import Logo from '../../ui-library/Logo';
import StyledContainer from '../../ui-library/styled/StyledContainer';
import useFooter from './useFooter';
import theme from '../../ui-library/theme';

const StyledFooterContainer = styled(StyledContainer)`
  min-height: 374px;
`;
const StyledFirstColumn = styled.div`
  padding-right: 64px;
  margin-bottom: 32px;
`;
const Footer = () => {
  const { showFooter } = useFooter();

  if (!showFooter) return null;

  return (
    <div style={{ backgroundColor: theme.colors.secondary.main }}>
      <StyledFooterContainer>
        <Row className='mt-5'>
          <Col md={4}>
            <StyledFirstColumn>
              <NewsletterSubscriptionWidget />
            </StyledFirstColumn>
          </Col>
          <Col md={3}>
            <SiteLinks />
          </Col>
          <Col md={3}>
            <ContactLinks />
          </Col>
          <Col md={2}>
            <SocialLinks />
          </Col>
        </Row>
      </StyledFooterContainer>
      <BottomBar />
    </div>
  );
};

export default Footer;
